(function () {
  function init() {
    var root = document.getElementById('ube-keuze');
    if (!root || root.getAttribute('data-ready') === '1') return;
    root.setAttribute('data-ready', '1');
    var kBox = document.getElementById('ube-klopper');
    var kId = parseInt(root.getAttribute('data-klopper-id'), 10);
    var kFull = parseInt(root.getAttribute('data-klopper-full'), 10) || 0;
    var kDisc = parseInt(root.getAttribute('data-klopper-disc'), 10) || kFull;
    var kPriceEl = root.querySelector('.ube-addon__price');
    var kNoteEl = root.querySelector('.ube-addon__note');
    var noteDefault = kNoteEl ? kNoteEl.textContent : '';

    function fmt(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }

    function update() {
      var r = root.querySelector('input[name="ube_qty"]:checked');
      if (!r) return;
      var q = parseInt(r.value, 10);
      document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="quantity"]').forEach(function (i) { i.value = q; });
      var kNow = q <= 2 ? kDisc : kFull;
      if (kPriceEl) {
        kPriceEl.innerHTML = q <= 2 ? '<s>' + fmt(kFull) + '</s> ' + fmt(kDisc) : fmt(kFull);
      }
      if (kNoteEl) {
        kNoteEl.textContent = q <= 2 ? noteDefault : 'Bij 3 of meer zakjes krijg je al de hogere zakjeskorting';
      }
      var total = parseInt(r.getAttribute('data-total'), 10);
      if (kBox && kBox.checked) total += kNow;
      document.querySelectorAll('.js-add-to-cart').forEach(function (b) {
        var s = b.querySelector(':scope > span');
        if (s && !b.disabled) s.textContent = 'In winkelwagen · ' + fmt(total);
      });
      root.querySelectorAll('.ube-opt').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
    }

    root.addEventListener('change', update);

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.js-add-to-cart');
      if (!b || !kBox || !kBox.checked || b.getAttribute('data-ube-k') === '1') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      b.setAttribute('data-ube-k', '1');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: kId, quantity: 1 }] })
      })
        .catch(function () {})
        .then(function () {
          kBox.checked = false;
          update();
          b.click();
          setTimeout(function () { b.removeAttribute('data-ube-k'); }, 1500);
        });
    }, true);

    update();
    window.addEventListener('load', update);
  }

  function trustpilot() {
    var anchor = document.querySelector('.template-product [data-block-id="title"]');
    if (!anchor || document.getElementById('ube-tp')) return;
    var box = document.createElement('p');
    box.id = 'ube-tp';
    box.className = 'ube-tp';
    box.innerHTML = '<a href="https://nl.trustpilot.com/review/ube25.com" target="_blank" rel="noopener"><span aria-hidden="true">★</span> Lees onze reviews op Trustpilot</a>';
    anchor.insertAdjacentElement('afterend', box);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); trustpilot(); });
  } else {
    init();
    trustpilot();
  }
})();
